// extracted by mini-css-extract-plugin
export default {"maxWidth":"dashboardPage_maxWidth__8ll5U","activeAnalyticsHeader":"dashboardPage_activeAnalyticsHeader__jr4Lj"};